module.exports = __webpack_public_path__ + "static/media/tribometro.357fe9cf.jpg";